import type { GTableBoxPaddingBase } from '~/presentation/ui';
import type { ReactNode } from 'react';

import { useGCampaignTableContext } from '../contexts';
import { Box, InlineGrid } from '@shopify/polaris';

export interface RowProps {
  children: ReactNode;
  padding?: GTableBoxPaddingBase;
  mode?: 'head' | 'body';
}
export const Row: React.FC<RowProps> = ({ children, padding, mode = 'body' }) => {
  const { columnHead, columnBody } = useGCampaignTableContext();

  return (
    <Box {...padding}>
      <InlineGrid alignItems="center" columns={mode === 'head' ? columnHead : columnBody}>
        {children}
      </InlineGrid>
    </Box>
  );
};
